import BootstrapModal from "react-bootstrap/Modal";
import Image from "../Image";
import CloseButton from "../CloseButton";

function ModalHeader({ title, closeButton, onHide }) {
  return (
    <BootstrapModal.Header>
      <div className="p-3 m-1" />

      {title ? (
        <p
          className="text-center mb-0"
          data-testid="modal-title"
        >
          {title}
        </p>
      ) : (
        <Image
          src="logo"
          alt="logo"
          style={{ height: "16px" }}
        />
      )}

      {closeButton ? (
        <CloseButton
          data-testid="modal-close-btn"
          onClick={onHide}
        />
      ) : (
        <div className="p-3 m-1" />
      )}
    </BootstrapModal.Header>
  );
}

export default ModalHeader;
